import { Injectable } from "@angular/core";
import { IGridsterDraggableOptions, IGridsterOptions } from "angular2gridster";
import { ConnectionStatus } from "ng2-signalr";
import { appSettings } from "../settings";
import { CommonService } from "./common.service";
import { DashboardService } from "./dashboard.service";
import { WidgethelperService } from "./widgethelper.service";
import {
  AgedOrdersService,
  AgedordersputwallService,
  AgedtasksService,
  AveragelocationccService,
  CurrentinventoryService,
  CurrentStateService,
  DefectivepartsService,
  HospitalsummaryService,
  InventoryaccuracyService,
  OntimeshipmentService,
  OpencctasksService,
  OpenorderService,
  OpenpickstasksService,
  OpenreplenstasksService,
  OrderstatusService,
  PackedunitsthroughputService,
  ParcelshipmentpctService,
  PickedunitsthroughputService,
  ProgresstrackingService,
  PulltimemonitorService,
  PutunitsthroughputService,
  ReturnsavailabilityService,
  StorewaveprogressionService,
  TotalactiveusersService,
  TotalcctasksService,
  TotalprogressionService,
  TransitionalInventoryService,
  VarianceService,
  WaveperformanceService,
  WaveprogressionService,
  WavepulltimemonitorService,
  WavesinqueueService,
  WavestatusService,
  WavetrendService,
  PendingWaveTasksService,
  OpensorterordersService,
  MhemessagesService,
  TimeincubbyService,
  CancelorderService,
  ShortedordersService,
  UserperformanceService,
  OpenordersService,
  PutawaynotconsumedService,
  HospitalpackedService,
  OrderfillrateService,
  ZonebalancingService,
  OrdersummaryService,
  HourlyordersService,
  ForcePackwavesService,
  ToteRecirculatingService,
  MheNoReadDataService,
  BlindCountErrorService,
  LargewavetrendService,
  WavestatusdashboardService,
  PutwallstatusdashboardService,
  CubbystatusdashboardService,
  OrdersByStoreService,
  HospitalPackedOrdersService,
  MheMonitoringSummaryService
}
  from "./widgets";

@Injectable()
export class WidgetService {
  constructor(
    private _commonSvc: CommonService,
    private _dashboardSvc: DashboardService,
    private _agedtasksSvc: AgedtasksService,
    private _currentinventorySvc: CurrentinventoryService,
    private _inventoryaccuracySvc: InventoryaccuracyService,
    private _hospitalsummarySvc: HospitalsummaryService,
    private _orderstatusSvc: OrderstatusService,
    private _packedunitsthroughputSvc: PackedunitsthroughputService,
    private _pickedunitsthroughputSvc: PickedunitsthroughputService,
    private _putunitsthroughputSvc: PutunitsthroughputService,
    private _progresstrackingSvc: ProgresstrackingService,
    private _pulltimemonitorSvc: PulltimemonitorService,
    private _returnsavailabilitySvc: ReturnsavailabilityService,
    private _storewaveprogressionSvc: StorewaveprogressionService,
    private _totalprogressionSvc: TotalprogressionService,
    private _totalactiveusersSvc: TotalactiveusersService,
    private _waveprogressionSvc: WaveprogressionService,
    private _wavepulltimemonitorSvc: WavepulltimemonitorService,
    private _wavestatusSvc: WavestatusService,
    private _wavetrendSvc: WavetrendService,
    private _waveperformanceSvc: WaveperformanceService,
    private _opencctasksSvc: OpencctasksService,
    private _totalcctasksSvc: TotalcctasksService,
    private _averagelocationccSvc: AveragelocationccService,
    private _varianceSvc: VarianceService,
    private _wavesinqueueSvc: WavesinqueueService,
    private _openpickstasksSvc: OpenpickstasksService,
    private _openreplenstasksSvc: OpenreplenstasksService,
    private _widgetHelper: WidgethelperService,
    private _agedOrdersSvc: AgedOrdersService,
    private _agedOrdersPutwallSvc: AgedordersputwallService,    
    private _parcelShipmentPctSvc: ParcelshipmentpctService,
    private _ontimeshipmentSvc: OntimeshipmentService,
    private _defectivepartsSvc: DefectivepartsService,
    private _openorderSvc: OpenorderService,
    private _transitionalInventorySvc: TransitionalInventoryService,
    private _currentStateSvc: CurrentStateService,
    private _pendingWaveTasksSvc: PendingWaveTasksService,
    private _opensorterordersSvc: OpensorterordersService,
    private _mhemessagesSvc: MhemessagesService,
    private _timeincubbySvc : TimeincubbyService,
    private _cancelorderSvc: CancelorderService,
    private _shortedOrdersSvc: ShortedordersService,
    private _userperformanceSvc: UserperformanceService,
    private _openOrdersSvc: OpenordersService,
    private _pncSvc: PutawaynotconsumedService,
    private _hospitalPackedSvc: HospitalpackedService,
    private _orderFillRateSvc: OrderfillrateService,
    private _zoneBalancingSvc: ZonebalancingService,
    private _orderSummarySvc: OrdersummaryService,
    private _hourlyOrdersSvc: HourlyordersService,
    private _forcePackwavesService: ForcePackwavesService,
    private _toteRecirculatingService: ToteRecirculatingService,
    private _mheNoReadDataService: MheNoReadDataService,
    private _blindCountErrorService: BlindCountErrorService,
    private _largeWaveTrendService: LargewavetrendService,
    private _waveStatusDashboardService: WavestatusdashboardService,
    private _putwallStatusDashboardService: PutwallstatusdashboardService,
    private _cubbyStatusDashboardService: CubbystatusdashboardService,
    private _ordersByStoreService: OrdersByStoreService,
    private _hospitalPackedOrdersService: HospitalPackedOrdersService,
    private _mheMonitoringSummaryService: MheMonitoringSummaryService
  ) { }

  gridsterOptions: IGridsterOptions = {
    lanes: 6, // how many lines (grid cells) dashboard has
    direction: "vertical", // items floating direction: vertical/horizontal/none
    floating: true, // default=true - prevents items to float according to the direction (gravity)
    dragAndDrop: true, // possible to change items position by drag n drop
    resizable: true, // possible to resize items by drag n drop by item edge/corner
    resizeHandles: {
      s: true,
      e: true,
      n: true,
      w: true,
      se: true,
      ne: true,
      sw: true,
      nw: true
    },
    widthHeightRatio: 1, // proportion between item width and height
    lines: {
      visible: false,
      color: "#afafaf",
      width: 2
    },
    shrink: true,
    useCSSTransforms: true, // Uses CSS3 translate() instead of position top/left - significant performance boost.
    responsiveView: true, // turn on adopting items sizes on window resize and enable responsiveOptions
    responsiveDebounce: 500, // window resize debounce time

    // List of different gridster configurations for different breakpoints.
    // Each breakpoint is defined by name stored in "breakpoint" property. There is fixed set of breakpoints
    // available to use with default minWidth assign to each.
    // - sm: 576 - Small devices
    // - md: 768 - Medium devices
    // - lg: 992 - Large devices
    // - xl: 1200 - Extra large
    // MinWidth for each breakpoint can be overwritten like it's visible below.
    // ResponsiveOptions can overwrite default configuration with any option available for specific breakpoint.
    responsiveOptions: [
      // {
      //   breakpoint: 'sm',
      //   lanes: 3
      // },
      // {
      //   breakpoint: 'md',
      //   minWidth: 768,
      //   lanes: 4,
      //   dragAndDrop: true,
      //   resizable: true
      // },
      {
        breakpoint: "lg",
        lanes: 6,
        dragAndDrop: true,
        resizable: true
      }
      // {
      //   breakpoint: 'xl',
      //   minWidth: 1800,
      //   lanes: 8,
      //   dragAndDrop: true,
      //   resizable: true
      // }
    ]
  };

  gridsterDraggableOptions: IGridsterDraggableOptions = {
    handlerClass: "panel-heading"
  };

  transformWidgets(widgets: Array<any>): Array<any> {
    console.log("transformWidgets", widgets);
    let newWidgets: Array<any> = [];

    widgets.forEach((widget, index) => {
      let transformedWidget = this.transformWidget(widget, index);
      newWidgets.push(transformedWidget);
    })

    newWidgets.sort((n1, n2) => {
      if (n1.y == n2.y) return n1.x - n2.x;
      else return n1.y - n2.y;
    });
    return newWidgets;
  }

  transformWidget(widget: any, index = 0): any {
    //console.log('transformWidget', widget);
    let newWidget: any = {};
    this.widgetDefaultValues(widget);
    let settings = {
      WidgetName: widget.widgetName,
      Type: widget.type,
      Sizewidth: widget.width,
      Sizeheight: widget.height,
      RefreshInterval: widget.refreshInterval,
      ShipmentType: widget.shipmentType,
      OrderPriority: widget.orderPriority,
      Carrier: widget.carrier,
      AppointmentDate: widget.appointmentDate,
      ShipToCountryCode: widget.shipToCountryCode,
      ItemNumber: widget.itemNumber,
      IsPast: widget.isPast,
      IsCurrent: widget.isCurrent,
      IsFuture: widget.isFuture,
      IsLithium: widget.isLithium,
      PickType: widget.pickType,
      ZoneAisle: widget.zoneAisle,
      PassThrus: widget.passThrus,
      widgetId: widget.widgetId,
      PositionX: widget.positionX,
      PositionY: widget.positionY,
      MonitorType: widget.monitorType,
      WaveCode: "0",
      WaveTitle: "All Waves",
      Criteria: widget.Criteria
    };
    let width = widget.width && widget.width <= 6 ? widget.width : 2;
    let height = widget.height && widget.height <= 6 ? widget.height : 3;
    newWidget = {
      x: widget.positionX,
      y: widget.positionY,
      w: width,
      h: height,
      i: index,
      indx: index,
      k: widget.type,
      type: widget.type,
      show: "true",
      widgetsettings: settings,
      widgetId: widget.widgetId,
      widgetName: widget.widgetName,
      Title: widget.title,
      DetailAPI: widget.DetailAPI,
      DataColumn: widget.DataColumn,
      DisplayColumn: widget.DisplayColumn,
      DataType: widget.DataType,
      Level2DetailAPI: widget.Level2DetailAPI,
      Level2DataColumn: widget.Level2DataColumn,
      Level2DisplayColumn: widget.Level2DisplayColumn,
      Level2DataType: widget.Level2DataType,
      ConnectionId: null,
      dragAndDrop: true,
      resizable: true,
      errorMessage: ""
    };

    console.log("transformWidget", newWidget);
    return newWidget;
  }

  widgetDefaultValues(widget: any) {
    switch (widget.type) {
      case appSettings.TotalProgression:
      case appSettings.OrderStatus:
      case appSettings.PullTimesMonitor:
      case appSettings.ProgressTracking:
      case appSettings.Waveprogression:
      case appSettings.Storewaveprogression:
      case appSettings.WavePullTimesMonitor:
      case appSettings.WaveOrderStatus:
      case appSettings.WaveTrend:
      case appSettings.CurrentInventory:
      case appSettings.TotalActiveUsers:
      case appSettings.PickedUnitsThroughput:
      case appSettings.PackedUnitsThroughput:
      case appSettings.PutUnitsThroughput:
      case appSettings.AgedTasks:
      case appSettings.OpenCCTasks:
      case appSettings.TotalCCTasks:
      case appSettings.LocationCC:
      case appSettings.OpenSorterOrders:
      case appSettings.MHEMessages:
      case appSettings.TimeInCubby:
      case appSettings.CancelOrders:
      case appSettings.UserPerformace:
      case appSettings.LargeWaveTrend:
      case appSettings.WaveOrdStatus:
      case appSettings.PutwallOrderStatus:
      case appSettings.CubbyOrderStatus:
        break;
      case appSettings.InventoryAccuracy:
      case appSettings.DefectiveParts:
      case appSettings.TransitionalInventory:
      case appSettings.OnTimeShipment:
        if (widget.pickType == "PostShip") {
          widget.pickType = appSettings.Last2Weeks;
        }
        if (widget.monitorType == "ORDERS") {
          widget.monitorType = "D";
        }

        break;
      case appSettings.ShortedOrders:
        if (widget.pickType == "PostShip") {
          widget.pickType = appSettings.US;
        }  
        break;
      default:
        break;
    }
  }

  loadWidget(widget: any) {
    //console.log('Widget Service');
    widget.errorMessage = null;
    widget.isWavePulltime = false;
    switch (widget.type) {
      case appSettings.TotalProgression:
        this._totalprogressionSvc.init(widget);
        break;
      case appSettings.OrderStatus:
        this._orderstatusSvc.init(widget);
        break;
      case appSettings.PullTimesMonitor:
        this._pulltimemonitorSvc.init(widget);
        break;
      case appSettings.ProgressTracking:
        this._progresstrackingSvc.init(widget);
        break;
      case appSettings.Waveprogression:
        this._waveprogressionSvc.init(widget);
        break;
      case appSettings.Storewaveprogression:
        this._storewaveprogressionSvc.init(widget);
        break;
      case appSettings.WavePullTimesMonitor:
        widget.isWavePulltime = true;
        this._wavepulltimemonitorSvc.init(widget);
        break;
      case appSettings.WaveOrderStatus:
        this._wavestatusSvc.init(widget);
        break;
      case appSettings.WaveTrend:
        this._wavetrendSvc.init(widget);
        break;
      case appSettings.WavePerformance:
        this._waveperformanceSvc.init(widget);
        break;
      case appSettings.CurrentInventory:
        this._currentinventorySvc.init(widget);
        break;
      case appSettings.ReturnsLocationsAvailability:
        this._returnsavailabilitySvc.init(widget);
        break;
      case appSettings.InventoryAccuracy:
        this._inventoryaccuracySvc.init(widget);
        break;
      case appSettings.HospitalSummary:
        this._hospitalsummarySvc.init(widget);
        break;
      case appSettings.TotalActiveUsers:
        this._totalactiveusersSvc.init(widget);
        break;
      case appSettings.PickedUnitsThroughput:
        this._pickedunitsthroughputSvc.init(widget);
        break;
      case appSettings.PackedUnitsThroughput:
        this._packedunitsthroughputSvc.init(widget);
        break;
      case appSettings.PutUnitsThroughput:
        this._putunitsthroughputSvc.init(widget);
        break;
      case appSettings.AgedTasks:
        this._agedtasksSvc.init(widget);
        break;
      case appSettings.OpenCCTasks:
        this._opencctasksSvc.init(widget);
        break;
      case appSettings.TotalCCTasks:
        this._totalcctasksSvc.init(widget);
        break;
      case appSettings.LocationCC:
        this._averagelocationccSvc.init(widget);
        break;
      case appSettings.Variance:
        this._varianceSvc.init(widget);
        break;
      case appSettings.WavesInQueue:
        this._wavesinqueueSvc.init(widget);
        break;
      case appSettings.OpenPicksTask:
        this._openpickstasksSvc.init(widget);
        break;
      case appSettings.OpenReplensTasks:
        this._openreplenstasksSvc.init(widget);
        break;
      case appSettings.AgedOrders:
        this._agedOrdersSvc.init(widget);
        break;
        case appSettings.AgedOrdersPutwall:
        this._agedOrdersPutwallSvc.init(widget);
        break;
      case appSettings.ShortedOrders:
        this._shortedOrdersSvc.init(widget);
        break; 
      case appSettings.HourlyOrders:
          this._hourlyOrdersSvc.init(widget);
          break;  
      case appSettings.OpenOrders:
        this._openOrdersSvc.init(widget);
        break;     
      case appSettings.PutawayNotConsumed:
        this._pncSvc.init(widget);
        break;  
      case appSettings.ParcelShipmentPct:
        this._parcelShipmentPctSvc.init(widget);
        break;
      case appSettings.OnTimeShipment:
        this._ontimeshipmentSvc.init(widget);
        break;
      case appSettings.DefectiveParts:
        this._defectivepartsSvc.init(widget);
        break;
      case appSettings.TransitionalInventory:
        this._transitionalInventorySvc.init(widget);
        break;
      case appSettings.CurrentState:
        this._currentStateSvc.init(widget);
        break;
      case appSettings.OpenOrder:
        this._openorderSvc.init(widget);
        break;
      case appSettings.PendingWaveTasks:
        this._pendingWaveTasksSvc.init(widget);
        break;
      case appSettings.OpenSorterOrders:
        this._opensorterordersSvc.init(widget);
        break;
      case appSettings.MHEMessages:
        this._mhemessagesSvc.init(widget);
        break;
      case appSettings.TimeInCubby:
        this._timeincubbySvc.init(widget);
        break;
      case appSettings.CancelOrders:
          this._cancelorderSvc.init(widget);
          break;
      case appSettings.UserPerformace:
          this._userperformanceSvc.init(widget);
          break;
      case appSettings.HospitalPackedPct:
          this._hospitalPackedSvc.init(widget);
          break;
      case appSettings.OrderFillRate:
          this._orderFillRateSvc.init(widget);
          break;
      case appSettings.ZoneBalancing:
          this._zoneBalancingSvc.init(widget);
          break;
      case appSettings.OrderSummary:
          this._orderSummarySvc.init(widget);
          break;          
      case appSettings.ForceClosedPackwaves:
          this._forcePackwavesService.init(widget);
          break;                
      case appSettings.ToteRecirculating:
          this._toteRecirculatingService.init(widget);
          break;            
      case appSettings.MHENoReadData:
          this._mheNoReadDataService.init(widget);
          break;            
      case appSettings.BlindCountError:
          this._blindCountErrorService.init(widget);
          break;      
      case appSettings.LargeWaveTrend:
          this._largeWaveTrendService.init(widget);
          break; 
      case appSettings.WaveOrdStatus:    
        this._waveStatusDashboardService.init(widget);
        break; 
      case appSettings.PutwallOrderStatus:
        this._putwallStatusDashboardService.init(widget);
        break;
      case appSettings.CubbyOrderStatus:
        this._cubbyStatusDashboardService.init(widget);
        break;
      case appSettings.OrdersByStore:
        this._ordersByStoreService.init(widget);
        break;
      case appSettings.HospitalPackedOrderSummary:
        this._hospitalPackedOrdersService.init(widget);
        break;  
      case appSettings.MHEMonitoringSummary:
        this._mheMonitoringSummaryService.init(widget);
        break;  
    }
  }

  reloadWidget(widget: any) {
    //console.log('Widget Service');
    widget.errorMessage = null;
    switch (widget.type) {
      case appSettings.TotalProgression:
        this._totalprogressionSvc.reload(widget);
        break;
      case appSettings.OrderStatus:
        this._orderstatusSvc.reload(widget);
        break;
      case appSettings.PullTimesMonitor:
        this._pulltimemonitorSvc.reload(widget);
        break;
      case appSettings.ProgressTracking:
        this._progresstrackingSvc.reload(widget);
        break;
      case appSettings.Waveprogression:
        this._waveprogressionSvc.reload(widget);
        break;
      case appSettings.Storewaveprogression:
        this._storewaveprogressionSvc.reload(widget);
        break;
      case appSettings.WavePullTimesMonitor:
        this._wavepulltimemonitorSvc.reload(widget);
        break;
      case appSettings.WaveOrderStatus:
        this._wavestatusSvc.reload(widget);
        break;
      case appSettings.WavePerformance:
        this._waveperformanceSvc.reload(widget);
        break;
      case appSettings.CurrentInventory:
        //re fetch the data again, plain DB call
        this._currentinventorySvc.init(widget);
        break;
      case appSettings.ReturnsLocationsAvailability:
        this._returnsavailabilitySvc.init(widget);
        break;
      case appSettings.InventoryAccuracy:
        this._inventoryaccuracySvc.init(widget);
        break;
      case appSettings.PickedUnitsThroughput:
        this._pickedunitsthroughputSvc.reload(widget);
        break;
      case appSettings.PackedUnitsThroughput:
        this._packedunitsthroughputSvc.reload(widget);
        break;
      case appSettings.PutUnitsThroughput:
        this._putunitsthroughputSvc.reload(widget);
        break;
      case appSettings.OpenCCTasks:
        this._opencctasksSvc.reload(widget);
        break;
      case appSettings.TotalCCTasks:
        this._totalcctasksSvc.reload(widget);
        break;
      case appSettings.LocationCC:
        this._averagelocationccSvc.reload(widget);
        break;
      case appSettings.Variance:
        this._varianceSvc.reload(widget);
        break;
      case appSettings.WavesInQueue:
        this._wavesinqueueSvc.reload(widget);
        break;
      case appSettings.OpenReplensTasks:
        this._openreplenstasksSvc.reload(widget);
        break;
      case appSettings.ParcelShipmentPct:
        this._parcelShipmentPctSvc.reload(widget);
        break;
      case appSettings.OnTimeShipment:
        this._ontimeshipmentSvc.init(widget);
        break;
      case appSettings.DefectiveParts:
        this._defectivepartsSvc.init(widget);
        break;
      case appSettings.TransitionalInventory:
        this._transitionalInventorySvc.init(widget);
        break;
      case appSettings.OpenOrder:
        this._openorderSvc.reload(widget);
        break;
      case appSettings.OrderSummary:
        this._orderSummarySvc.init(widget);
        break;   
      case appSettings.AgedTasks:
      case appSettings.WaveTrend:
      case appSettings.TotalActiveUsers:
      case appSettings.OpenPicksTask:
      case appSettings.AgedOrders:
      case appSettings.AgedOrdersPutwall:
      case appSettings.ShortedOrders:
      case appSettings.CurrentState:
      case appSettings.PendingWaveTasks:
      case appSettings.OpenSorterOrders:
      case appSettings.MHEMessages:
      case appSettings.TimeInCubby:
      case appSettings.UserPerformace:
      case appSettings.OpenOrders:
      case appSettings.PutawayNotConsumed:
      case appSettings.HourlyOrders:  
      case appSettings.LargeWaveTrend:
      case appSettings.WaveOrdStatus:
      case appSettings.PutwallOrderStatus: 
      case appSettings.CubbyOrderStatus:         
        this._widgetHelper.reload(widget);
        break;
      case appSettings.HospitalPackedPct:
        this._hospitalPackedSvc.init(widget);
        break;
      case appSettings.OrderFillRate:
        this._orderFillRateSvc.init(widget);
        break;
      case appSettings.ZoneBalancing:
          this._zoneBalancingSvc.init(widget);
          break;
      case appSettings.ForceClosedPackwaves:
          this._forcePackwavesService.init(widget);
          break;                
      case appSettings.ToteRecirculating:
          this._toteRecirculatingService.init(widget);
          break;            
      case appSettings.MHENoReadData:
          this._mheNoReadDataService.init(widget);
          break;            
      case appSettings.BlindCountError:
          this._blindCountErrorService.init(widget);
          break;   
      case appSettings.OrdersByStore:
        this._ordersByStoreService.init(widget);
        break;   
      case appSettings.HospitalPackedOrderSummary:
        this._hospitalPackedOrdersService.init(widget);
        break;
      case appSettings.MHEMonitoringSummary:
        this._mheMonitoringSummaryService.init(widget);
        break; 
    }
  }

  removeWidget(widget: any) {
    switch (widget.type) {
      case appSettings.TotalProgression:
        this._totalprogressionSvc.remove(widget);
        break;
      case appSettings.OrderStatus:
        this._orderstatusSvc.remove(widget);
        break;
      case appSettings.PullTimesMonitor:
        this._pulltimemonitorSvc.remove(widget);
        break;
      case appSettings.ProgressTracking:
        this._progresstrackingSvc.remove(widget);
        break;
      case appSettings.Waveprogression:
        this._waveprogressionSvc.remove(widget);
        break;
      case appSettings.Storewaveprogression:
        this._storewaveprogressionSvc.remove(widget);
        break;
      case appSettings.WavePullTimesMonitor:
        this._wavepulltimemonitorSvc.remove(widget);
        break;
      case appSettings.WaveOrderStatus:
        this._wavestatusSvc.remove(widget);
        break;
      case appSettings.WavePerformance:
        this._waveperformanceSvc.remove(widget);
        break;
      case appSettings.CurrentInventory:
        this._currentinventorySvc.remove(widget);
        break;
      case appSettings.ReturnsLocationsAvailability:
        this._returnsavailabilitySvc.remove(widget);
        break;
      case appSettings.InventoryAccuracy:
        this._inventoryaccuracySvc.remove(widget);
        break;
      case appSettings.PickedUnitsThroughput:
        this._pickedunitsthroughputSvc.remove(widget);
        break;
      case appSettings.PackedUnitsThroughput:
        this._packedunitsthroughputSvc.remove(widget);
        break;
      case appSettings.PutUnitsThroughput:
        this._putunitsthroughputSvc.remove(widget);
        break;
      case appSettings.OpenCCTasks:
        this._opencctasksSvc.remove(widget);
        break;
      case appSettings.TotalCCTasks:
        this._totalcctasksSvc.remove(widget);
        break;
      case appSettings.LocationCC:
        this._averagelocationccSvc.remove(widget);
        break;
      case appSettings.Variance:
        this._varianceSvc.remove(widget);
        break;
      case appSettings.WavesInQueue:
        this._wavesinqueueSvc.remove(widget);
        break;
      case appSettings.OpenReplensTasks:
        this._openreplenstasksSvc.remove(widget);
        break;
      case appSettings.ParcelShipmentPct:
        this._parcelShipmentPctSvc.remove(widget);
        break;
      case appSettings.OpenOrder:
        this._openorderSvc.remove(widget);
        break;
      case appSettings.AgedTasks:
      case appSettings.WaveTrend:
      case appSettings.TotalActiveUsers:
      case appSettings.OpenPicksTask:
      case appSettings.AgedOrders:
      case appSettings.AgedOrdersPutwall:
      case appSettings.ShortedOrders:
      case appSettings.CurrentState:
      case appSettings.PendingWaveTasks:
      case appSettings.OpenSorterOrders:
      case appSettings.MHEMessages:
      case appSettings.TimeInCubby:
      case appSettings.UserPerformace:
      case appSettings.OpenOrders:
      case appSettings.PutawayNotConsumed:
      case appSettings.HourlyOrders:       
      case appSettings.ForceClosedPackwaves:
      case appSettings.ToteRecirculating:
      case appSettings.MHENoReadData:
      case appSettings.BlindCountError:
      case appSettings.LargeWaveTrend:
      case appSettings.WaveOrderStatus:
      case appSettings.PutwallOrderStatus:
      case appSettings.CubbyOrderStatus:
        this._widgetHelper.remove(widget);
        break;  
      case appSettings.HospitalPackedPct:
        this._hospitalPackedSvc.remove(widget);
        break; 
      case appSettings.OrderFillRate:
        this._orderFillRateSvc.remove(widget);
        break; 
      case appSettings.ZoneBalancing:  
        this._zoneBalancingSvc.remove(widget); 
        break;   
      case appSettings.OrdersByStore:
        this._ordersByStoreService.remove(widget);
        break;
      case appSettings.MHEMonitoringSummary:
        this._mheMonitoringSummaryService.init(widget);
        break; 
    }
  }

  refreshWidget(widget: any) {
    if (widget.chartOptions) {
      let chartOptions: any = this._commonSvc.deepClone(widget.chartOptions);
      widget.Options = {};
      //console.log('widget.chartOptions',widget.chartOptions);
      //console.log('chartOptions',chartOptions);
      widget.chartOptions = chartOptions;
    }

    if (widget.UnitsPie) {
      let UnitsPie: any = this._commonSvc.deepClone(widget.UnitsPie);
      widget.UnitsPie = {};
      widget.UnitsPie = UnitsPie;
    }

    if (widget.OrdersPie) {
      let OrdersPie: any = this._commonSvc.deepClone(widget.OrdersPie);
      widget.OrdersPie = {};
      widget.OrdersPie = OrdersPie;
    }

    if (widget.QuantityPie) {
      let QuantityPie: any = this._commonSvc.deepClone(widget.QuantityPie);
      widget.QuantityPie = {};
      widget.QuantityPie = QuantityPie;
    }

    if (widget.StoresPie) {
      let StoresPie: any = this._commonSvc.deepClone(widget.StoresPie);
      widget.StoresPie = {};
      widget.StoresPie = StoresPie;
    }
  }

  deleteAllWidgets() {
    let hub = this._dashboardSvc.startConnection();

    hub.status.subscribe((status: ConnectionStatus) => {
      console.log("signalr status :", status);
    });

    hub.errors.subscribe((error: any) => {
      console.log("signalr errors :", error);
    });

    let widgetData = [];
    hub
      .start()
      .then(() => {
        hub
          .invoke("DeleteAllWidgetsByID", widgetData)
          .then(data => {
            console.log("DeleteAllWidgetsByID", data);
          })
          .catch(err => {
            console.log("Error DeleteAllWidgetsByID", err);
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widget.service.ts